module.exports = require('./helpers/bundle-url').getBundleURL('4AlMw') + "ios.10df819a.png" + "?" + Date.now();